<route>
{
  "meta": {
    "permission": [
      "auth.view_user"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      api="user"
      app="auth.user"
      :otherBtn="userBtn.view"
      :title="$tc('user', 1)"
      :headers="headers"
      :otherPermission="userBtn.edit && userBtn.rol"
      :opt="isAdmin ? null : { company: this.company.pk }"
      @click:create="changeRoute({ id: 'create' })"
      @click:edit="changeRoute($event, true)"
    >
      <template v-slot:otherBtn="{ item }">
        <i-btn
          classes="mx-1"
          color="info"
          icon="fas fa-eye"
          outlined
          :title="$t('see')"
          @click="changeRoute(item)"
        />
      </template>
      <template v-slot:item.state="{ item }">
        {{ item.profile ? item.profile.state : '' }}
      </template>
      <template v-slot:item.groups="{ value }">
        <div class="pt-1">
          <span v-for="(group, i) in value" :key="`group-${i}`">
            <v-chip v-if="i < 5" class="mb-1 mr-1" small>
              {{ group.name }}
            </v-chip>
            <span v-else class="font-weight-black">...</span>
          </span>
        </div>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    headers() {
      return [
        {
          text: this.$tc('username', 1),
          value: 'username'
        },
        {
          text: this.$t('first_name'),
          value: 'first_name'
        },
        {
          text: this.$t('last_name'),
          value: 'last_name'
        },
        {
          text: this.$tc('email', 1),
          value: 'email'
        },
        ...this.companyHeader,
        {
          text: this.userBtn.rol ? this.$tc('roles', 1) : '',
          value: this.userBtn.rol ? 'groups' : ''
        },
        {
          text: this.userBtn.edit || this.userBtn.view ? this.$t('action') : '',
          value: this.userBtn.edit || this.userBtn.view ? 'actions' : ''
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData'
    }),
    userBtn() {
      return {
        rol: this.getPermissions([`auth.view_group`]) || this.isAdmin,
        permissions:
          this.getPermissions([`auth.view_permission`]) || this.isAdmin,
        edit: this.getPermissions([`users.change_profile`]) || this.isAdmin,
        view: this.getPermissions([`users.view_profile`]) || this.isAdmin
      }
    },
    companyHeader() {
      return this.isAdmin
        ? [
            {
              text: this.$t('company'),
              value: 'company.name'
            }
          ]
        : []
    }
  },
  methods: {
    changeRoute(item, needEdit = false) {
      this.$router.push({
        name: 'users-pk',
        params: {
          pk: this.codification({ code: item.id }),
          edit: needEdit
        }
      })
    }
  }
}
</script>
